import Reflux from 'reflux';

module.exports = Reflux.createActions([
  'update',
  'fastUpdate',
  'destroy',
  'changeDate'
]);
